import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41dbba76"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_2 = {
  key: 0,
  class: "unsaved"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "You have unsaved changes", -1))
const _hoisted_4 = {
  key: 0,
  class: "rm-dot-bounce"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot-bounce dot--one" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot-bounce dot--two" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot-bounce dot--three" }, null, -1))
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Save Now")
const _hoisted_10 = {
  key: 1,
  class: "flex items-center justify-center py-2 text-white uppercase bg-secondary-dark-1"
}
const _hoisted_11 = {
  key: 0,
  class: "text-center"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Opening in", -1))
const _hoisted_13 = {
  key: 1,
  class: "text-center"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Locking in", -1))
const _hoisted_15 = {
  key: 2,
  class: "text-center"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Current Match", -1))
const _hoisted_17 = {
  key: 3,
  class: "text-center"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Results are being finalized", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "flex flex-col items-center justify-center pb-24 my-2 text-center gap-y-2" }
const _hoisted_22 = {
  key: 0,
  class: "rm-dot-bounce"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot-bounce dot--one" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot-bounce dot--two" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot-bounce dot--three" }, null, -1))
const _hoisted_26 = [
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Set Status")
const _hoisted_29 = { class: "flex gap-x-2" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Open")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Locked")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Finalizing")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Closed")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Tools")
const _hoisted_35 = { class: "flex gap-x-2" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Run Scoring")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Download Results")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Loading scorecard...")

import { useScorecardStore } from '@/store/scorecards';
import { useWrestlerStore } from '@/store/wrestlers';
import { useRoute } from 'vue-router';
import {
  computed,
  inject,
  onBeforeUnmount,
  onMounted,
  provide,
  Ref,
  ref,
  toRefs,
  watch,
} from 'vue';
import Image from '@/components/Scorecard/Image.vue';
import PlayerDetails from '@/components/Scorecard/PlayerDetails.vue';
import { useUserStore } from '@/store/users';
import Match from '@/components/Scorecard/Match.vue';
import Tables from '@/components/Scorecard/Tables.vue';
import Briefcases from '@/components/Scorecard/Briefcases.vue';
import Unscheduleds from '@/components/Scorecard/Unscheduleds.vue';
import Scheduled from '@/components/Scorecard/Scheduled.vue';
import PotentialScore from '@/components/Scorecard/PotentialScore.vue';
import {
  MatchResponse,
  ScorecardDisplayState,
  ScorecardStatus,
  ScorecardViewMode,
} from '@/typings/scorecard';
import CountdownTimer from '@/components/UI/CountdownTimer.vue';
import SectionTitle from '@/components/UI/SectionTitle.vue';
import { Sockets } from '@/typings/sockets';
import { AlertModal } from '@/typings/modal';
import { apiScorecards } from '@/api/scorecard';
import { ScorecardLockedError } from '@/exception/scorecard';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

function serialize(obj: any): string {
  if (Array.isArray(obj)) {
    return JSON.stringify(obj.map((i) => serialize(i)));
  } else if (typeof obj === 'object' && obj !== null) {
    return Object.keys(obj)
      .sort()
      .map((k) => `${k}:${serialize(obj[k])}`)
      .join('|');
  }

  return obj;
}

const route = useRoute();
const wrestlerStore = useWrestlerStore();
const scorecardStore = useScorecardStore();
const userStore = useUserStore();
const { slug, user: loadingUser } = route.params;

const { scorecard } = toRefs(scorecardStore);
const { user } = toRefs(userStore);

const alertModal = inject('alertModal') as Ref<AlertModal>;

const resultsMode = !!route.meta['isAdmin'];
provide('resultsMode', resultsMode);

let viewMode = ScorecardViewMode.Public;

if (resultsMode) {
  viewMode = ScorecardViewMode.Results;
}

if (loadingUser || user.value) {
  viewMode = ScorecardViewMode.User;
}

provide('viewMode', viewMode);

const unsavedChanges = ref(false);
let hash = ref('');

const open = ref(0);
provide('open', open);
onMounted(async () => {
  await wrestlerStore.getWrestlers();
  await wrestlerStore.getTeams();
  if (loadingUser) {
    await scorecardStore.getScorecardForUser(
      slug.toString(),
      loadingUser.toString()
    );
  } else if (resultsMode) {
    await scorecardStore.getCorrectScorecard(slug.toString());
  } else {
    await scorecardStore.getScorecardBySlug(slug.toString());
  }

  hash.value = serialize(scorecardStore.scorecard?.usersAnswers);
  unsavedChanges.value = false;
});

onBeforeUnmount(() => {
  scorecardStore.scorecard = undefined;
});

watch(
  () => scorecardStore.scorecard?.usersAnswers,
  () => {
    unsavedChanges.value =
      serialize(scorecardStore.scorecard?.usersAnswers) !== hash.value;
  },
  { deep: true }
);

const isEditable = computed(
  () =>
    (scorecardStore.displayState === ScorecardDisplayState.Editable &&
      !loadingUser) ||
    resultsMode
);

const $socket: Sockets = inject('$socket') as Sockets;
$socket.on(
  'scorecard-status',
  ({ status, slug }: { status: string; slug: string }) => {
    if (slug === scorecard?.value?.event.Slug) {
      if (status === 'Finalising') {
        scorecard.value.event.Status = ScorecardStatus.Finalizing;
      } else {
        scorecard.value.event.Status =
          ScorecardStatus[status as keyof typeof ScorecardStatus];
        if (status === 'Locked' && !resultsMode) {
          onSave();
        }
      }
    }
  }
);
$socket.on(
  'current-match',
  ({ match, slug }: { match: string; slug: string }) => {
    if (slug === scorecard?.value?.event.Slug) {
      scorecard.value.event.CurrentMatch = match;
    }
  }
);

function getMatchResponse(id: number, correct = false) {
  if (scorecard?.value) {
    if (resultsMode || correct) {
      const found = scorecard.value.correctAnswers.Matches.find(
        (match) => match.MatchId === id
      );
      if (found) {
        return found;
      }
    }
    if (!scorecard.value.usersAnswers) {
      return {} as MatchResponse;
    }
    const found = scorecard.value.usersAnswers.Matches.find(
      (match) => match.MatchId === id
    );
    if (found) {
      return found;
    }
  }
  return {} as MatchResponse;
}

function getTableResponse() {
  if (scorecard?.value) {
    if (resultsMode) {
      return scorecard.value.correctAnswers.Tables;
    }
    return scorecard.value.usersAnswers.Tables;
  }
  return [];
}

function getBriefcaseResponse() {
  if (scorecard?.value) {
    if (resultsMode) {
      return scorecard.value.correctAnswers.Briefcases;
    }
    return scorecard.value.usersAnswers.Briefcases;
  }
  return [];
}

function getUnscheduledResponse() {
  if (scorecard?.value) {
    if (resultsMode) {
      return scorecard.value.correctAnswers.Unscheduled;
    }
    return scorecard.value.usersAnswers.Unscheduled;
  }
  return [];
}

async function onSave() {
  if (scorecardStore.submitting) return;
  if (scorecard?.value) {
    if (resultsMode) {
      scorecard.value.correctAnswers.Correct = true;
      await scorecardStore.savePredictions(scorecard.value.correctAnswers);
      hash.value = serialize(scorecardStore.scorecard?.usersAnswers);
      unsavedChanges.value = false;
      alertModal.value.show(
        'Results Saved',
        'Results have been successfully saved.'
      );
    } else {
      scorecard.value.usersAnswers.Correct = false;
      try {
        await scorecardStore.savePredictions(scorecard.value.usersAnswers);
        hash.value = serialize(scorecardStore.scorecard?.usersAnswers);
        unsavedChanges.value = false;
        alertModal.value.show(
          'Predictions Saved',
          'Predictions have been successfully saved.'
        );
      } catch (error) {
        if (error instanceof ScorecardLockedError) {
          alertModal.value.show(
            'Predictions Not Saved - Scorecard Locked',
            'Your predictions have not been saved as the scorecard is locked.'
          );
        } else {
          alertModal.value.show(
            'Predictions Not Saved - Something went wrong',
            'Your predictions have not been saved as something unexpected has occurred.'
          );
        }
      }
    }
  }
}

const currentMatchName = computed(() => {
  if (!scorecard?.value?.event.CurrentMatch) {
    return '';
  } else {
    const match = scorecard.value.event.Matches.find(
      (m) => m.MatchId == scorecard.value?.event.CurrentMatch
    );
    return `${match?.Title} ${match?.Subtitle}`.trim();
  }
});

async function setStatus(status: string) {
  await scorecardStore.setStatus(status);
}

async function runScoring() {
  if (scorecard?.value?.event?.Slug) {
    await apiScorecards.postRunScoring(scorecard.value.event.Slug);
  }
}

async function downloadResults() {
  if (scorecard?.value?.event?.Slug) {
    const response = await apiScorecards.getResults(scorecard.value.event.Slug);
    const type = response.headers['content-type'];
    const fileName = response.headers['content-disposition']
      .split('filename=')[1]
      .split(';')[0];
    const blob = new Blob([response.data], { type });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_unref(scorecard))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (unsavedChanges.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              (_unref(isEditable))
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    onClick: onSave,
                    disabled: _unref(scorecardStore).submitting
                  }, {
                    default: _withCtx(() => [
                      (_unref(scorecardStore).submitting)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_8))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_9
                          ], 64))
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(Image, {
          scorecard: _unref(scorecard).event
        }, null, 8, ["scorecard"]),
        _createVNode(PlayerDetails, {
          user: _unref(user),
          viewing: (_unref(loadingUser) || '').toString(),
          "unsaved-changes": unsavedChanges.value
        }, null, 8, ["user", "viewing", "unsaved-changes"]),
        (
        (_unref(scorecardStore).displayState !== _unref(ScorecardDisplayState).View ||
          _unref(scorecard).event.CurrentMatch) &&
        _unref(scorecard).event.Status !== 'Closed'
      )
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_unref(scorecard).event.Status === 'Scheduled')
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("div", null, [
                      _createVNode(CountdownTimer, {
                        end: new Date(_unref(scorecard).event.OpensAt)
                      }, null, 8, ["end"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(scorecard).event.Status === 'Open')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", null, [
                      _createVNode(CountdownTimer, {
                        end: new Date(_unref(scorecard).event.LocksAt)
                      }, null, 8, ["end"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(scorecard).event.Status === 'Locked')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", null, _toDisplayString(_unref(currentMatchName)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_unref(scorecard).event.Status === 'Finalising')
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(scorecard).event.Matches, (match) => {
          return (_openBlock(), _createBlock(Match, {
            key: match.MatchId,
            match: match,
            disabled: !_unref(isEditable),
            response: getMatchResponse(match.MatchId || 0),
            "correct-response": getMatchResponse(match.MatchId || 0, true)
          }, null, 8, ["match", "disabled", "response", "correct-response"]))
        }), 128)),
        (_unref(scorecard).event.Tables.length > 0)
          ? (_openBlock(), _createBlock(Tables, {
              key: 2,
              tables: _unref(scorecard).event.Tables,
              response: getTableResponse(),
              disabled: !_unref(isEditable),
              "correct-response": _unref(scorecard).correctAnswers.Tables
            }, null, 8, ["tables", "response", "disabled", "correct-response"]))
          : _createCommentVNode("", true),
        (_unref(scorecard).event.Briefcases.length > 0)
          ? (_openBlock(), _createBlock(Briefcases, {
              key: 3,
              briefcases: _unref(scorecard).event.Briefcases,
              response: getBriefcaseResponse(),
              disabled: !_unref(isEditable),
              "correct-response": _unref(scorecard).correctAnswers.Briefcases
            }, null, 8, ["briefcases", "response", "disabled", "correct-response"]))
          : _createCommentVNode("", true),
        (_unref(scorecard).event.Unscheduleds > 0)
          ? (_openBlock(), _createBlock(Unscheduleds, {
              key: 4,
              unscheduledCount: _unref(scorecard).event.Unscheduleds,
              response: getUnscheduledResponse(),
              disabled: !_unref(isEditable),
              "correct-response": _unref(scorecard).correctAnswers.Unscheduled
            }, null, 8, ["unscheduledCount", "response", "disabled", "correct-response"]))
          : _createCommentVNode("", true),
        (_unref(scorecard).event.Unscheduleds > 0)
          ? (_openBlock(), _createBlock(Scheduled, {
              key: 5,
              scheduleds: _unref(scorecard).event.Scheduled
            }, null, 8, ["scheduleds"]))
          : _createCommentVNode("", true),
        _createVNode(PotentialScore, {
          score: _unref(scorecard).event.PossibleScore
        }, null, 8, ["score"]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", null, [
            (_unref(isEditable))
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  onClick: onSave,
                  disabled: _unref(scorecardStore).submitting
                }, {
                  default: _withCtx(() => [
                    (_unref(scorecardStore).submitting)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_26))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_27
                        ], 64))
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ]),
          (resultsMode || _unref(user)?.PrivilegeId == 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", null, [
                  _createVNode(SectionTitle, null, {
                    default: _withCtx(() => [
                      _hoisted_28
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_Button, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (setStatus('Open')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_30
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Button, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (setStatus('Locked')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_31
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Button, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (setStatus('Finalising')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_32
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Button, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (setStatus('Closed')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_33
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(SectionTitle, null, {
                    default: _withCtx(() => [
                      _hoisted_34
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_Button, { onClick: runScoring }, {
                      default: _withCtx(() => [
                        _hoisted_36
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Button, { onClick: downloadResults }, {
                      default: _withCtx(() => [
                        _hoisted_37
                      ]),
                      _: 1
                    })
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createBlock(_component_Spinner, { key: 1 }, {
        default: _withCtx(() => [
          _hoisted_38
        ]),
        _: 1
      }))
}
}

})